namespace Matrix.Visualizer {
    export class GraphNodeColumns {
        static columnsKey = 'Visualizer.GraphNode';
    }
}
